import { ExportTypeNames } from 'constants/exportTypes';

import { blue } from '@mui/material/colors';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert } from 'shared/mui/Alert/Alert';
import { Checkbox } from 'shared/mui/Checkbox/Checkbox';
import { NotifyDialog, NotifyDialogProps } from 'shared/mui/Dialogs';
import { FormControlLabel } from 'shared/mui/FormControlLabel/FormControlLabel';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';

type Props = Omit<NotifyDialogProps, 'message'> & {
  exportType: ExportTypeNames;
  userEmail?: string;
  sendOnEmail: boolean;
  onChange: VoidFunction;
};

export const ReportExportDialog: React.FC<Props> = ({
  isLoading,
  exportType,
  userEmail,
  sendOnEmail,
  onChange,
  ...restProps
}) => {
  const translate = useTypedTranslate();
  const hasEmail = Boolean(userEmail);

  return (
    <NotifyDialog
      isLoading={isLoading}
      maxWidth="lg"
      message={
        <Stack gap="24px">
          <Typography component="span">
            {translate('app.orders.reportWillBeConverted', { exportType })}
          </Typography>
          <FormControlLabel
            control={<Checkbox checked={sendOnEmail} onChange={onChange} />}
            disabled={!hasEmail}
            label={
              <>
                <Typography component="span">
                  {translate('app.orders.duplicateEmailSending')}{' '}
                </Typography>
                {hasEmail && (
                  <Typography color={blue[500]} component="span">
                    {userEmail}
                  </Typography>
                )}
              </>
            }
            sx={{ marginRight: 0, marginLeft: 0 }}
          />
          {!hasEmail && (
            <Alert severity="info">{translate('app.common.emailRequiredInProfile')}.</Alert>
          )}
        </Stack>
      }
      sx={{
        '& .MuiDialog-paper': {
          width: '640px',
        },
      }}
      {...restProps}
    />
  );
};
